import {Switch} from '@headlessui/react'

export const SwitchInput = (props) => {

  const {enabled, setEnabled, name, iconUrl} = props

  return(
    <div className="flex items-center text-sm h-10">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={`${enabled ? 'bg-teal-600' : 'bg-gray-300'}
          relative inline-flex h-[21px] w-[37px] shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2  focus-visible:ring-white focus-visible:ring-opacity-75`}
      >
        <span className="sr-only">Auswahl aktivieren</span>
        <span
          aria-hidden="true"
          className={`${enabled ? 'translate-x-4' : 'translate-x-0'}
            pointer-events-none inline-block h-[17px] w-[17px] transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out`}
        />
      </Switch>
      <img
        src={iconUrl} alt={name}
        className="w-8 h-8 mx-2" />
      <div>
        <div className="">{name}</div>
      </div>
    </div>
  )
}